import type { Route } from '~/core/router'

import * as bundles from '~/routes/shows/bundles'
import * as details from '~/routes/shows/details'
import * as subcategories from '~/routes/shows/subcategories'
import * as subcategory from '~/routes/shows/subcategory'

export const route: Route = {
  children: [
    {
      path: ['/:showId', '/:showId/seasons/:seasonId'],
      component: [details.Title, details.ShowDetailsPage],
      init: details.model.init,
      left: details.model.left,
      meta: {
        contentId(params: { showId: string }) {
          return Number(params.showId)
        },
      },
    },
    {
      path: '/:showId/seasons',
      action: (__, { showId }) => ({
        redirect: `/content/series/${showId}`,
      }),
      meta: {
        contentId(params: { showId: string }) {
          return Number(params.showId)
        },
      },
    },
    {
      path: '/bundles/:bundleId',
      component: [bundles.Title, bundles.ShowBundlesPage],
      init: bundles.model.initShowsBundlePage,
      left: bundles.model.left,
    },
    {
      path: [
        '/categories/:categoryId',
        '/categories/:categoryId/subcategories/:subCategoryId',
      ],
      component: [subcategory.Title, subcategory.ShowCategoriesPage],
      init: subcategory.model.initShowSubCategory,
      left: subcategory.model.left,
    },
    {
      path: '/categories/:categoryId/subcategories',
      component: [subcategories.Title, subcategories.ShowSubCategoriesPage],
      init: subcategories.model.initShowSubCategories,
      left: subcategories.model.left,
    },
  ],
}
